import { createAction, props } from '@ngrx/store';
import { UserDetails } from '../../components/login/user.model';

export const loginSuccess = createAction(
  '[User] Login Success',
  props<{ user: UserDetails }>()
);
export const logout = createAction('[User] Logout');
export const getUserData = createAction('[User] Get User Data');
export const userData = createAction(
  '[User] Fetch User Data',
  props<{ user: UserDetails }>()
);
